import { SxProps } from '@mui/material'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import React, { ChangeEvent, ReactNode } from 'react'
import TextField from '@mui/material/TextField'
import { appActions, selectAppEditable } from '../../../../entities/Application'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { FieldErrors, UseFormRegister } from 'react-hook-form'

interface AppNameInputProps {
	styles: SxProps
	register?: UseFormRegister<any>
	validationErrors?: FieldErrors<any>
}

export const AppNameInput = (props: AppNameInputProps) => {
	const { styles, register, validationErrors: errors } = props
	const dispatch = useAppDispatch()
	const { applicationName } = useAppSelector(selectAppEditable)

	const handleAppNameChange = (
		e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		dispatch(appActions.setAppName(e.target.value))
	}

	return (
		<TextField
			required
			fullWidth
			sx={styles}
			variant="outlined"
			id="app-name-input"
			label="Application name"
			helperText={
				(errors?.applicationName?.message as ReactNode) || ''
			}
			error={!!errors?.applicationName?.message}
			{...register?.('applicationName', {
				required: 'This field is required'
			})}
			value={applicationName || ''}
			onChange={handleAppNameChange}
		/>
	)
}